var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:_vm.classObject,attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){_vm.$listeners.click || _vm.onClick},"mouseover":function($event){return _vm.mouseOver($event)},"mouseleave":function($event){return _vm.mouseOut($event)}}},[_vm._v(_vm._s(_vm.getTitle))])
}
var staticRenderFns = []

export { render, staticRenderFns }